<template>
	<div class="add-item-header">
		<div v-if="title" class="add-item-title" id="item-name" tabindex="0" :aria-label="title">{{ title }}</div>
		<button type="button" class="modal-close-button" @click.prevent="handleClick">
			<span class="screen-reader">Close Add Item</span>
			<div class="icon-close">
				<div class="icon-close-inner"></div>
			</div>
		</button>
	</div>
</template>

<script>
export default {
	name: "AddItemHeader",
	props: {
		title: String,
	},
	mounted() {
		document.getElementById("item-name").focus();
	},
	methods: {
		handleClick() {
			this.$emit("close-modal");
		},
	},
};
</script>

<style lang="scss" scoped>
.add-item-header {
	background-color: #ffffff;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
	border-bottom: 1px solid rgb(231, 231, 231);
	height: 80px;
	display: flex;
	justify-content: center;
	align-items: flex-end;
}

.add-item-title {
	font-size: 2.8rem;
	font-weight: 900;
}

.screen-reader {
	@include screen-reader-text;
}

.modal-close-button {
	@include transition(color);
	color: $black;
	position: absolute;
	right: 3%;
	top: 3%;
	height: 40px;
	width: 40px;

	&:hover,
	&:focus {
		color: $gold;
	}
}

.icon-close {
	position: absolute;
	right: 50%;
	top: 0;
}

.icon-close-inner {
	&::before,
	&::after {
		content: "";
		display: block;
		background-color: currentColor;
		width: 6px;
		height: 33px;
		position: absolute;
		border-radius: 100px;

		@media (min-width: $mobileLandscape) {
			width: 6px;
			height: 53px;
		}
	}

	&::before {
		transform: translate(-50%, -3px) rotate(45deg);
	}

	&::after {
		transform: translate(-50%, -3px) rotate(-45deg);
	}
}
</style>